module.exports = __webpack_public_path__ + "assets/img/roof-2.ce366e1c.jpg";